export const ADVOKATNOEGLE_MOBILE_HELPER =
  "Vær opmærksom på, at det oplyste mobilnummer vil blive offentliggjort på Advokatnøglen.";

export type EmployeePhoneFieldConfig = {
  label: string;
  isRequired: boolean;
  helperText?: string;
};

export const requiredTelefonnummerField: EmployeePhoneFieldConfig = {
  label: "Telefonnummer",
  isRequired: true,
};

export const optionalMobilnummerField: EmployeePhoneFieldConfig = {
  label: "Mobilnummer",
  isRequired: false,
  helperText: ADVOKATNOEGLE_MOBILE_HELPER,
};
